import { render } from "./ServicesDirectoryDataSection.vue?vue&type=template&id=dd962696&scoped=true"
import script from "./ServicesDirectoryDataSection.vue?vue&type=script&lang=js"
export * from "./ServicesDirectoryDataSection.vue?vue&type=script&lang=js"

import "./ServicesDirectoryDataSection.vue?vue&type=style&index=0&id=dd962696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd962696"]])

export default __exports__